/**
 * 정산 관리 협력사 API 클라이언트
 */
import { apiClient } from "@/shared/api/client";
import { PartnerListItem, PartnerNameItem, PartnerSearchFilters } from "../types/AccountingPartner.types";

const BASE_PATH = '/api/v1/withdrawal-limit/partner';

/**
 * AccountingPartner API 서비스
 */
export const partnerAccountingApi = {
    /**
     * 협력사 목록 조회
     * GET /api/v1/withdrawal-limit/partner/list
     */
    getPartnerList: async (): Promise<PartnerListItem[]> => {
        const response = await apiClient.get<PartnerListItem[]>(
            `${BASE_PATH}/list`
        );
        return response.data;
    },

    /**
     * 협력사 검색
     * GET /api/v1/withdrawal-limit/partner/search
     */
    searchPartners: async (filters: PartnerSearchFilters): Promise<PartnerListItem[]> => {
        const response = await apiClient.get<PartnerListItem[]>(
            `${BASE_PATH}/search`,
            { params: filters }
        );
        return response.data;
    },

    /**
     * 협력사명 목록 조회
     * GET /api/v1/withdrawal-limit/partner/names
     */
    getPartnerNames: async (): Promise<PartnerNameItem[]> => {
        const response = await apiClient.get<PartnerNameItem[]>(
            `${BASE_PATH}/names`
        );
        return response.data;
    },

    /**
     * 출금제한 설정
     * POST /api/v1/withdrawal-limit/partner/withdrawal
     */
    updateWithdrawalStatus: async (suppId: string, withdrawalYn: 'Y' | 'N'): Promise<void> => {
        await apiClient.post<void>(
            `${BASE_PATH}/withdrawal`,
            {
                suppId,
                withdrawalYn
            }
        );
    }
};
